import { render, staticRenderFns } from "./student-attendance.vue?vue&type=template&id=410d56a8&scoped=true"
import script from "./student-attendance.vue?vue&type=script&lang=js"
export * from "./student-attendance.vue?vue&type=script&lang=js"
import style0 from "./student-attendance.vue?vue&type=style&index=0&id=410d56a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410d56a8",
  null
  
)

export default component.exports